// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3xLmy","itemTitle":"ClientEmergencyInfo_itemTitle__JFu0_","itemText":"ClientEmergencyInfo_itemText__2VrXa"};